import { render, staticRenderFns } from "./AutoBlockCard.vue?vue&type=template&id=0110e5ce&scoped=true&"
import script from "./AutoBlockCard.vue?vue&type=script&lang=js&"
export * from "./AutoBlockCard.vue?vue&type=script&lang=js&"
import style0 from "./AutoBlockCard.vue?vue&type=style&index=0&id=0110e5ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110e5ce",
  null
  
)

export default component.exports